/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerStreamResponseQueryResponse, ChatControllerStreamResponsePathParams, ChatControllerStreamResponse401, ChatControllerStreamResponse403 } from "../../models/chatController/ChatControllerStreamResponse";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { chatControllerStreamResponse } from "../../clients/chatService/chatControllerStreamResponse";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const chatControllerStreamResponseQueryKey = (requestId: ChatControllerStreamResponsePathParams["requestId"]) => [{
  url: '/api/v1/chat/stream/:requestId',
  params: {
    requestId: requestId
  }
}] as const;
export type ChatControllerStreamResponseQueryKey = ReturnType<typeof chatControllerStreamResponseQueryKey>;
export function chatControllerStreamResponseQueryOptions(requestId: ChatControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = chatControllerStreamResponseQueryKey(requestId);
  return queryOptions<ChatControllerStreamResponseQueryResponse, ResponseErrorConfig<ChatControllerStreamResponse401 | ChatControllerStreamResponse403>, ChatControllerStreamResponseQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return chatControllerStreamResponse(requestId, config);
    }
  });
}

/**
 * @summary Stream chat responses via Server-Sent Events
 * {@link /api/v1/chat/stream/:requestId}
 */
export function useChatControllerStreamResponse<TData = ChatControllerStreamResponseQueryResponse, TQueryData = ChatControllerStreamResponseQueryResponse, TQueryKey extends QueryKey = ChatControllerStreamResponseQueryKey>(requestId: ChatControllerStreamResponsePathParams["requestId"], options: {
  query?: Partial<QueryObserverOptions<ChatControllerStreamResponseQueryResponse, ResponseErrorConfig<ChatControllerStreamResponse401 | ChatControllerStreamResponse403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? chatControllerStreamResponseQueryKey(requestId);
  const query = useQuery({
    ...chatControllerStreamResponseQueryOptions(requestId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ChatControllerStreamResponse401 | ChatControllerStreamResponse403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}